import { HTMLProps } from "react";
import { cn } from "../libs/cn";

const baseSelectStyles = `block w-full rounded text-base border py-2.5 border-gray-300 text-gray-700 focus:outline-none focus:ring-red-300/50 focus:ring-2 focus:ring-offset-0 focus:border-red-200`;

export const Select = ({
  children,
  error,
  className,
  ...props
}: SelectProps) => {
  return (
    <select
      className={cn(
        baseSelectStyles,
        error ? `border-red-600 border-2` : undefined,
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
};

export interface SelectProps extends HTMLProps<HTMLSelectElement> {
  error?: string;
}
